import React, { useRef, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { documentAPI } from '../../api';
import { toast } from 'sonner';

// Load-level documents (same UX as the stop Documents modal)
export const LoadDocumentsDialog = ({ open, onOpenChange, loadId, documents, onChange }) => {
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const docs = documents || [];

  const handleUpload = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const response = await documentAPI.upload(file, 'load', loadId, 'load_document', `Load Document: ${file.name}`);
      const fileUrl = `${process.env.REACT_APP_BACKEND_URL}${response.data.file_url}`;
      onChange([...docs, fileUrl]);
      toast.success('Document added — remember to Save');
    } catch {
      toast.error('Failed to upload document');
    } finally {
      setUploading(false);
    }
  };

  const remove = (i) => {
    const next = [...docs];
    next.splice(i, 1);
    onChange(next);
  };

  const fileName = (url) => decodeURIComponent(url.split('/').pop() || '').replace(/^[0-9a-f-]{36}_/i, '');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="lw-load-documents-modal">
        <DialogHeader>
          <DialogTitle>Documents — Load Info</DialogTitle>
          <DialogDescription className="sr-only">Upload documents related to this load</DialogDescription>
        </DialogHeader>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {docs.length === 0 && <p style={{ fontSize: 13, color: 'var(--lw-muted)' }}>No documents yet.</p>}
          {docs.map((url, i) => (
            <div key={url} style={{ display: 'flex', alignItems: 'center', gap: 8, border: '1px solid var(--lw-border)', borderRadius: 4, padding: 6 }}>
              <a href={url} target="_blank" rel="noreferrer" className="lw-link" style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} data-testid={`lw-load-document-link-${i}`}>
                {fileName(url) || `Document ${i + 1}`}
              </a>
              <button className="lw-btn" style={{ height: 24, padding: '0 8px', color: 'var(--lw-red)' }} onClick={() => remove(i)} data-testid={`lw-load-document-remove-${i}`}>✕</button>
            </div>
          ))}
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
            style={{ display: 'none' }}
            onChange={(e) => { handleUpload(e.target.files?.[0]); e.target.value = ''; }}
            data-testid="lw-load-document-file-input"
          />
          <button className="lw-btn primary" disabled={uploading} onClick={() => fileInputRef.current?.click()} data-testid="lw-load-document-upload-btn">
            {uploading ? 'Uploading...' : '+ Add Document'}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
